import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import Tooltip from '../../../tooltip';
import Paragraph from '../../../paragraph';
import { TOOLTIP_PROP_TYPES } from '../../../tooltip/types';

const RadioButton = ({
  checked = undefined,
  defaultChecked = undefined,
  disabled = false,
  id,
  label,
  name,
  onChange,
  tooltipProps = null,
  value,
  isLabelBold = false,
}) => {
  const isMobile = bowser.mobile;
  const isTablet = bowser.tablet;
  const isTouchDevice = isMobile || isTablet;
  const isTooltipEnabled = tooltipProps && !isTouchDevice && !disabled;
  const classes = classNames('ws-ui-radio-button', {
    'ws-ui-radio-button--disabled': disabled,
    'ws-ui-radio-button--touch-device': isTouchDevice,
  });

  const handleChange = (event) => {
    onChange(event.currentTarget.value, event);
  };

  const tooltipAttributesForLabel =
    (tooltipProps &&
      !isTouchDevice && {
        'data-tip': true,
        'data-for': tooltipProps.id,
      }) ||
    {};

  return (
    <React.Fragment>
      <label htmlFor={id} className={classes} {...tooltipAttributesForLabel}>
        <input
          checked={checked}
          className="ws-ui-radio-button__input"
          defaultChecked={defaultChecked}
          disabled={disabled}
          id={id}
          name={name}
          onChange={handleChange}
          type="radio"
          value={value}
        />
        <div className="ws-ui-radio-button__label">
          <Paragraph appearance={disabled ? 'low-emphasis' : 'high-emphasis'}>
            {isLabelBold ? <b>{label}</b> : label}
          </Paragraph>
        </div>
      </label>
      {isTooltipEnabled && <Tooltip {...tooltipProps} />}
    </React.Fragment>
  );
};

RadioButton.propTypes = {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  tooltipProps: PropTypes.shape(TOOLTIP_PROP_TYPES),
  value: PropTypes.string.isRequired,
  isLabelBold: PropTypes.bool,
};

export default RadioButton;
